"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrySector = void 0;
var IndustrySector;
(function (IndustrySector) {
    IndustrySector["TOWN_HALL"] = "TOWN_HALL";
    IndustrySector["COMMUNITY_OF_COMMUNES"] = "COMMUNITY_OF_COMMUNES";
    IndustrySector["INSURANCE"] = "INSURANCE";
    IndustrySector["HOSPITAL_SECTOR"] = "HOSPITAL_SECTOR";
    IndustrySector["SCHOOL"] = "SCHOOL";
    IndustrySector["BANK"] = "BANK";
    IndustrySector["PRIVATE"] = "PRIVATE";
    IndustrySector["OTHER"] = "OTHER";
})(IndustrySector || (exports.IndustrySector = IndustrySector = {}));
//# sourceMappingURL=industrySector.enum.js.map